import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { CookieService } from 'ngx-cookie-service';
import { DeviceDetectionModule } from '@wdpr/ra-angular-device-detection';

import { GENESYS_CHAT_CONFIG, GenesysChatModuleConfig } from './interfaces/genesys-chat-module-config.interface';
import { GenesysChatFactory } from './services/genesys-chat.factory';
import { GenesysChatService } from './services/genesys-chat.service';
import { GenesysWebChatComponent } from './components/genesys-web-chat/genesys-web-chat.component';
import { WindowRef } from '../window-ref/window-ref.service';

@NgModule({
    imports: [
        CommonModule,
        DeviceDetectionModule
    ],
    declarations: [
        GenesysWebChatComponent
    ],
    exports: [
        GenesysWebChatComponent
    ]
})
export class GenesysWebChatModule {
    // For Angular 9 migration https://angular.io/guide/migration-module-with-providers
    static forRoot(config: GenesysChatModuleConfig): ModuleWithProviders {
        return {
            ngModule: GenesysWebChatModule,
            providers: [
                CookieService,
                WindowRef,
                {
                    provide: GenesysChatService,
                    useFactory: GenesysChatFactory,
                    deps: [ GENESYS_CHAT_CONFIG, WindowRef ],
                },
                config.configProvider
            ]
        };
    }
}
